import type { IJournalResult } from '../../store/types';
import type { Comments } from './types';

export const getEmptyJournalResult = (): IJournalResult => ({
  questions: [],
  dpdg: { date_time: '', comment: '' },
  emotions: [],
  mac_cards: [],
  wheel: [],
  color_code: [],
  clouds: [],
  result: '',
});

export function buildJournalResultSaveBody(
  baseMeetData: IJournalResult,
  commentsData: Comments,
): { result: IJournalResult[] } {
  return {
    result: [
      {
        questions: baseMeetData.questions || [],
        dpdg: baseMeetData.dpdg
          ? {
              ...baseMeetData.dpdg,
              comment: commentsData?.dpdg || baseMeetData.dpdg.comment || '',
            }
          : { date_time: '', comment: commentsData?.dpdg || '' },
        emotions:
          baseMeetData.emotions?.map((el, idx) => ({
            ...el,
            comment: commentsData?.emotions?.[idx] ?? el.comment ?? '',
          })) || [],
        mac_cards:
          baseMeetData.mac_cards?.map((el, idx) => ({
            ...el,
            comment: commentsData?.mac_cards?.[idx] ?? el.comment ?? '',
          })) || [],
        result: commentsData?.result || '',
        wheel:
          baseMeetData.wheel?.map((el, idx) => ({
            ...el,
            comment: commentsData?.wheels?.[idx] ?? el.comment ?? '',
          })) || [],
        color_code:
          baseMeetData.color_code?.map((el, idx) => ({
            ...el,
            comment: commentsData?.color_code?.[idx] ?? el.comment ?? '',
          })) || [],
        clouds:
          baseMeetData.clouds?.map((el, idx) => ({
            ...el,
            comment: commentsData?.clouds?.[idx] ?? el.comment ?? '',
          })) || [],
        sand_therapy: baseMeetData.sand_therapy?.map((el, idx) => ({
          ...el,
          comment: commentsData?.sand_therapy?.[idx] ?? el.comment ?? '',
        })),
        mac_cards_by_participant: baseMeetData.mac_cards_by_participant
          ? Object.fromEntries(
              Object.entries(baseMeetData.mac_cards_by_participant).map(([id, entries]) => [
                id,
                entries.map((e, i) => ({
                  ...e,
                  comment: commentsData.mac_cards_by_participant?.[id]?.[i] ?? e.comment ?? '',
                })),
              ]),
            )
          : undefined,
        emotions_by_participant: baseMeetData.emotions_by_participant
          ? Object.fromEntries(
              Object.entries(baseMeetData.emotions_by_participant).map(([id, entries]) => [
                id,
                entries.map((e, i) => ({
                  ...e,
                  comment: commentsData.emotions_by_participant?.[id]?.[i] ?? e.comment ?? '',
                })),
              ]),
            )
          : undefined,
        group_participant_names: baseMeetData.group_participant_names,
        session_conclusion_by_participant:
          Object.keys(commentsData.session_conclusion_by_participant ?? {}).length > 0
            ? commentsData.session_conclusion_by_participant
            : baseMeetData.session_conclusion_by_participant,
      },
    ],
  };
}
